/**
 * FileUploadScorecardActions are actions related to the CRUD of file upload scorecards
 */
import alt from 'components/Dispatcher';

class FileUploadScorecardActions {
  constructor() {
    this.generateActions(
      'fetchScorecards',
      'fetchScorecardsError',
      'fetchScorecardsLoading',
      'fetchScorecardsSuccess',
      'fetchScorecardResults',
      'fetchScorecardResultsError',
      'fetchScorecardResultsLoading',
      'fetchScorecardResultsSuccess',
      'submitScorecardResultsLoading',
      'submitScorecardResultsError',
      'submitScorecardResultsSuccess',
      'clearAnswers'
    );
  }
}

export default alt.createActions(FileUploadScorecardActions);
